/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What languages is Toolverse available in?`)
};

const es_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué idiomas está disponible Toolverse?`)
};

const de_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welchen Sprachen ist Toolverse verfügbar?`)
};

const nl_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In welke talen is Toolverse beschikbaar?`)
};

const fr_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans quelles langues Toolverse est-il disponible ?`)
};

const it_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In quali lingue è disponibile Toolverse?`)
};

const pt_br2_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em quais idiomas a Toolverse está disponível?`)
};

const pt_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que idiomas está disponível a Toolverse?`)
};

const ja_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseはどの言語に対応していますか？`)
};

const zh_home_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse 支持哪些语言？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_faq3_q", locale)
	if (locale === "en") return en_home_faq3_q(inputs)
	if (locale === "es") return es_home_faq3_q(inputs)
	if (locale === "de") return de_home_faq3_q(inputs)
	if (locale === "nl") return nl_home_faq3_q(inputs)
	if (locale === "fr") return fr_home_faq3_q(inputs)
	if (locale === "it") return it_home_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_home_faq3_q(inputs)
	if (locale === "pt") return pt_home_faq3_q(inputs)
	if (locale === "ja") return ja_home_faq3_q(inputs)
	return zh_home_faq3_q(inputs)
};